import React from "react";
import PropTypes from "prop-types";
import { ControlTooltip } from "./ControlTooltip";
import { PlungerTooltip } from "./PlungerTooltip";
import {
  TUBE,
  TRASH,
  GLASS_TUBE,
  PLUNGER_TOOLTIP_TYPE,
} from "../MicroPipette.constants";

export function MicroPipetteTooltip(props) {
  switch (props.contactElement.type) {
    case GLASS_TUBE:
    case TUBE:
      return (
        <PlungerTooltip
          type={props.label}
          onMix={props.onMix}
          elementId={props.contactElement.id}
          plungerTooltip={props.plungerTooltip}
          onFirstStopper={props.onFirstStopper}
          onSecondStopper={props.onSecondStopper}
          togglePlungerTooltip={props.togglePlungerTooltip}
          openMoveMenu={props.openMoveMenu}
          showMoveMenu={props.showMoveMenu}
          onSetHamburgerButtonRef={props.onSetHamburgerButtonRef}
        />
      );
    case TRASH:
    default:
      return (
        <ControlTooltip
          show={props.show}
          label={props.label}
          volume={props.volume}
          hoverPlaceholderSize={150}
          onRemoveTip={props.onRemoveTip}
          openVolumeModal={props.openVolumeModal}
          openMoveMenu={props.openMoveMenu}
          showMoveMenu={props.showMoveMenu}
          onSetHamburgerButtonRef={props.onSetHamburgerButtonRef}
        />
      );
  }
}

MicroPipetteTooltip.propTypes = {
  /**
   * Type of MicroPipette
   */
  type: PlungerTooltip.propTypes.type,
  /**
   * Boolean to show/hide the Controls Tooltip Icons
   */
  show: PropTypes.bool,
  /**
   * Label to display on Tooltip
   */
  label: PropTypes.string,
  /**
   * Callback to OpenVolumeModal Icon Click
   */
  openVolumeModal: PropTypes.func,
  /**
   * Callback to open move menu modal
   */
  openMoveMenu: PropTypes.func,
  /**
   * Callback to Remove any attached tip on Micropipette
   */
  onRemoveTip: PropTypes.func,
  /**
   * Apparatus currently interacting with MicroPipette
   */
  contactElement: PropTypes.shape({
    /**
     * Type of Apparatus currently in contact with MicroPipette
     */
    type: PropTypes.oneOf(["", TRASH, GLASS_TUBE, TUBE]),
    /**
     * UniqueId of Apparatus currently in contact with MicroPipette
     */
    id: PropTypes.number,
  }),
  /**
   *  Plunger Tooltip set as current
   */
  plungerTooltip: PropTypes.oneOf([
    PLUNGER_TOOLTIP_TYPE.MIXER,
    PLUNGER_TOOLTIP_TYPE.STOPPER,
  ]),
  /**
   * Funtion to toggle currentPlungerTooltip
   */
  togglePlungerTooltip: PropTypes.func,
  /**
   * Callback function for First Stopper Press
   */
  onFirstStopper: PropTypes.func,
  /**
   * Callback function for Second Stopper Press
   */
  onSecondStopper: PropTypes.func,
  /**
   * Callback function for Mixer Operation
   */
  onMix: PropTypes.func,
  /**
   * showMoveMenu to check moveMenu to display or not
   */
  showMoveMenu: PropTypes.bool,
  /**
   * Callback to set hamburger button ref for focus management
   */
  onSetHamburgerButtonRef: PropTypes.func,
};

MicroPipetteTooltip.defaultProps = {
  show: false,
  contactElement: {
    type: "",
    id: undefined,
  },
};
